import { Spinner } from "react-bootstrap";
import Main from "../../../layout/main";
import "./style.scss";

export default function Preloader() {
  return (
    <Main className={"preloader"}>
      {/* logo  */}
      <div className="logo">
        <img
          src="/static/images/svg/logo.svg"
          alt="logo"
          width={225}
          height={64}
        />
      </div>
      <Spinner animation="border" variant="primary" />{" "}
    </Main>
  );
}
